import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { useQuery } from '@sequencehq/api'

export const useAutomationExecution = ({
  executionId
}: {
  executionId: string | null
}) => {
  const automationExecutionQuery = useQuery(
    dashboardv99990101Client.getAutomationExecution,
    { id: executionId ?? '' },
    {
      enabled: !!executionId,
      refetchInterval: query =>
        query.state.data?.status === 'RUNNING' ? 5000 : false
    }
  )

  return {
    isPending: !!executionId && automationExecutionQuery.isPending,
    isPolling:
      automationExecutionQuery.isFetching &&
      !automationExecutionQuery.isPending,
    automationExecution: automationExecutionQuery.data,
    triggerType: automationExecutionQuery.data?.input?.triggerType
  }
}
